import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '@env/environment';
import { GS1ButtonDirective, GS1CardComponent } from '@gs1france/gs1-components-library';
import { TranslateModule } from '@ngx-translate/core';
import { TagsService } from '../../core/services/tags.service';

@Component({
  selector: 'app-home-account-codes',
  imports: [TranslateModule, RouterLink, GS1ButtonDirective, GS1CardComponent],
  templateUrl: './home-account-codes.component.html',
  styleUrl: './home-account-codes.component.scss'
})
export class HomeAccountCodesComponent {
  environment = environment;

  constructor(private readonly tagsService: TagsService) {}

  accessAccount(): void {
    this.tagsService.sendEvent('acceder_compte');
  }

  accessCodeOnline(): void {
    this.tagsService.sendEvent('acceder_code_online');
  }
}
